export const SEARCHED_WORD_CLASS_NAME = 'searched'
export const UNDERLINED_WORD_CLASS_NAME = 'underlined'

export function useTextSearch(index) {
  const searchedWords = document.getElementsByClassName(
    SEARCHED_WORD_CLASS_NAME
  )

  if (!searchedWords.length) {
    return
  }

  if (searchedWords[index - 1]) {
    searchedWords[index - 1].classList.remove(UNDERLINED_WORD_CLASS_NAME)
  }

  if (searchedWords[index + 1]) {
    searchedWords[index + 1].classList.remove(UNDERLINED_WORD_CLASS_NAME)
  }

  searchedWords[index].classList.add(UNDERLINED_WORD_CLASS_NAME)
  searchedWords[index].scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  })
}
